import React from 'react';
import { Icon } from 'antd';

export default function OnboardingOptionalStepNotice({ message, tone = 'default' }) {
  if (!message) return null;

  return (
    <div
      className={`onboarding-registration-optional-notice onboarding-registration-optional-notice--${tone}`}
      role="note"
    >
      <Icon type="info-circle" aria-hidden />
      <span>{message}</span>
    </div>
  );
}
